import { FC } from "react"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import { ColorVariant } from "@/types/index"

export interface UserContentInfoProps {
   variant: ColorVariant
   iconName?: IconProps["name"]
   iconSize?: string
   headerText?: string
   contentText?: string
   facilityName?: string
   headerTestId?: string
}

const UserContentInfo: FC<UserContentInfoProps> = ({
   variant,
   iconName,
   iconSize = "91",
   headerText,
   contentText,
   facilityName,
   headerTestId,
}) => {
   return (
      <div className="user-modal__content-info">
         {(iconName || headerText) && (
            <div className="user-modal__content-info-header">
               {iconName && (
                  <Icon
                     name={iconName}
                     size={iconSize}
                     color={
                        variant === ColorVariant.SILVER ||
                        variant === ColorVariant.COOL_GRAY
                           ? IconColor.WHITE
                           : IconColor.GUNMETAL
                     }
                  />
               )}
               {headerText && (
                  <span
                     className="user-modal__content-info-header-text"
                     {...(headerTestId && { "data-testid": headerTestId })}
                  >
                     {headerText}
                  </span>
               )}
            </div>
         )}
         {contentText && (
            <div className="user-modal__content-info-description">
               {contentText}
               {facilityName && (
                  <div className="user-modal__content-info-facility-name">
                     {facilityName}
                  </div>
               )}
            </div>
         )}
      </div>
   )
}

export default UserContentInfo
